/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export enum WebActionTypeDTO {
    redirect = 'redirect',
    new_tab = 'new_tab',
    internal_navigation = 'internal_navigation',
}
